import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  Clock,
  Calendar,
  Filter,
  Bell,
  Key,
  MessageSquare,
} from "lucide-react";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const POST_TYPES = {
  NEWS: "news",
  EVENT: "event",
  LOST_FOUND: "lost_found",
  ANNOUNCEMENT: "announcement",
};

export const DATE_FILTERS = [
  { id: "today", label: "Today", icon: Clock },
  { id: "week", label: "This Week", icon: Calendar },
  { id: "all", label: "All Time", icon: Filter },
];

export const filterCategories = [
  { id: "all", label: "All", icon: Filter },
  { id: POST_TYPES.NEWS, label: "News", icon: Bell },
  { id: POST_TYPES.EVENT, label: "Events", icon: Calendar },
  { id: POST_TYPES.LOST_FOUND, label: "Lost & Found", icon: Key },
  { id: POST_TYPES.ANNOUNCEMENT, label: "Announcements", icon: MessageSquare },
];

export const getCategoryColor = (category) => {
  const colorMap = {
    news: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    event:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    lost_found: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    announcement:
      "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  };
  return (
    colorMap[category] ||
    "bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-400"
  );
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatCommentDate = (date) => {
  const commentDate = new Date(date);
  const now = new Date();
  const diffMs = now - commentDate;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hr ago`;
  if (diffDays < 7) return `${diffDays} days ago`;

  return commentDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export const getInitials = (name) => {
  if (!name) return "U";
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

export const isInDateRange = (postDate, filter) => {
  const date = new Date(postDate);
  const today = new Date();
  const weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);

  switch (filter) {
    case "today":
      return date.toDateString() === today.toDateString();
    case "week":
      return date >= weekAgo;
    default:
      return true;
  }
};
